import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

@Injectable()
export class InstallStatisticsExportService {
  constructor (private http: Http) {
  }

  /** 导出软件视图安装统计 */
  downloadSoftwareViewStatistics (moduleName: string) {
    return this.http.downloadWithBlob('/softmgr/terminal-authentic-soft-version/export', {}, moduleName)
  }

  /** 导出终端视图安装统计 */
  downloadTerminalViewStatistics (moduleName: string) {
    return this.http.downloadWithBlob('/softmgr/terminal-authentic-soft/export', {}, moduleName)
  }
}

